export default __webpack_public_path__ + "static/media/location-step-active.40e11664.svg";